





























import Vue from 'vue';
import Review from '@/ui/components/review/Review.vue';
import HTransitionLoader from '@/ui/components/base/HTransitionLoader.vue';
import { ObjectLike } from '../../../types/objectlike.types';

export default Vue.extend({
  name: 'ReviewList',
  components: {
    Review,
    HTransitionLoader,
  },
  props: {
    reviews: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    loadMore(entries: ObjectLike[]) {
      this.$emit('load', entries);
    },
  },
});
